<template>
  <div>
    <el-tabs v-model="allActiveName" @tab-click="handleTab">
      <el-tab-pane
        v-for="(item, index) in allTabList"
        :key="'tabList' + index"
        :label="returnPaneLabel(item.name, item.value)"
        :name="item.state + ''"
      >
        <!-- 待履约 -->
        <el-tabs
          v-if="allActiveName === '10'"
          type="card"
          v-model="stayProcessActiveName"
          @tab-click="handleTab"
        >
          <el-tab-pane
            v-for="(item, index) in stayProcessTabList"
            :key="'stayProcessTabsList' + index"
            :label="returnPaneLabel(item.name, item.value)"
            :name="item.state + ''"
          >
          </el-tab-pane>
        </el-tabs>

        <!-- 退车核算 -->
        <el-tabs
          v-if="allActiveName === '3'"
          type="card"
          v-model="accountingActiveName"
          @tab-click="handleTab"
        >
          <el-tab-pane
            v-for="(item, index) in accountingTabList"
            :key="'tabList' + index"
            :label="returnPaneLabel(item.name, item.value)"
            :name="item.state + ''"
          >
          </el-tab-pane>
        </el-tabs>
      </el-tab-pane>
    </el-tabs>

    <!-- 列表数据 -->
    <list @handleSummary="getSummary" ref="PersonalOrderList" :levelTab="allActiveName" :tabNo="tabNo"/>
  </div>
</template>
<script>
// eslint-disable-next-line import/no-cycle
import listConfig from '../config/index'
import list from './list.vue'
import { TabListSeven } from '@/api/purchaseAndSaleAPI'
import { parseQueryJsonStr } from '@/utils/querySchema'

export default {
  name: 'listTab',
  components: { list },
  data() {
    const { allTabList, stayProcessTabList, accountingTabList } = listConfig.call(this)
    return {
      allTabList,
      stayProcessTabList,
      accountingTabList,
      allActiveName: '0',
      stayProcessActiveName: '10',
      accountingActiveName: '3',
      tabNo: '0',
    }
  },
  created() {
    this.getRouteQuery()
    this.getSummary()
  },
  methods: {
    // 获取路由参数
    getRouteQuery() {
      // 数据报表跳转
      const queryStr = this.$route.query.query
      // 数据报表
      if (queryStr) {
        const { tab } = parseQueryJsonStr(queryStr)
        // tab
        if (tab) {
          this.tabNo = Number(tab)
          this.allActiveName = tab // tab回显
        }
      }
    },
    // tab数据----请求数据
    async getSummary() {
      const { code, data } = await TabListSeven({ bizType: 10 })
      if (code !== 1) return
      Object.keys(data).forEach((item) => {
        this.allTabList.forEach((arr) => {
          if (arr.key === item) {
            arr.value = data[item]
            return false
          }
        })
        this.stayProcessTabList.forEach((arr) => {
          if (arr.key === item) {
            arr.value = data[item]
            return false
          }
        })
        this.accountingTabList.forEach((arr) => {
          if (arr.key === item) {
            arr.value = data[item]
            return false
          }
        })
      })
    },
    returnPaneLabel(val, content) {
      if (content) {
        return `${val} ( ${content} ) `
      } else {
        return `${val} ( 0 ) `
      }
    },
    handleTab(e) {
      this.$nextTick(() => {
        const $ref = this.$refs.PersonalOrderList
        this.tabNo = e.name
        this.$nextTick(() => {
          $ref.goReset('tabSwitch')
        })
      })
    },
  },
}
</script>
